import { Box, Grid, Typography } from '@mui/material';
import { Selector } from 'components/Form/Selectors/Selector';
import { ThemePalette } from 'mui.theme';
import { useAppSelector } from 'store/hook';
import { type Asset } from 'types/asset.types';
import {
  addLiveDataToAssets,
  isAssetIgnition,
} from 'views/FleetOverview/helpers/asset.helpers';
import { useTranslation } from 'react-i18next';
import { CLIENT_THEME, clientThemePalette } from 'utils/clientTheme';
export const AssetSelector = ({
  enableDarkTheme,
  makeModels,
  selectedMakeModel,
  setSelectedMakeModel,
  assetBumperIds,
  selectedAsset,
  setSelectedAsset,
  inputWidth = '200px',
  latestTagData,
}: {
  enableDarkTheme: boolean;
  makeModels: string[];
  selectedMakeModel: string;
  setSelectedMakeModel: any;
  assetBumperIds: string[];
  selectedAsset: Asset;
  setSelectedAsset: any;
  inputWidth?: string;
  latestTagData?: any;
}) => {
  const palette = enableDarkTheme
    ? clientThemePalette[CLIENT_THEME].dark
    : clientThemePalette[CLIENT_THEME].light;
  const { t } = useTranslation();
  const { assets } = useAppSelector((state) => state.assetReducer);
  const assetsWithLiveData = addLiveDataToAssets(assets, latestTagData);
  const makeModelList = makeModels.map((item) => {
    return {
      id: item,
      display: item,
    };
  });

  const assetList = assetBumperIds.map((item) => {
    return {
      id: item,
      display: item,
      bumperId: true,
      isActive: latestTagData
        ? isAssetIgnition(
            latestTagData,
            assetsWithLiveData.find(
              (asset) => asset.bumperNumber === item
            ) as Asset
          )
        : undefined,
    };
  });

  return (
    <Grid item sm={12} md={6} lg={4}>
      <Box
        sx={{
          borderRadius: '5px',
          marginTop: '7px',
          backgroundColor: enableDarkTheme
            ? palette.boxBackground
            : palette.boxBackground,
          height: '80px',
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        {/* Make Model */}
        <Box
          sx={{
            paddingLeft: '10px',
            paddingRight: '10px',
          }}
        >
          <Typography
            variant="bodyBold"
            display="block"
            mb={'4px'}
            sx={{
              paddingBottom: '20px',
            }}
          >
            {t('make_model')}
          </Typography>
          <Selector
            minWidth={inputWidth}
            value={selectedMakeModel}
            onChange={(event) => {
              setSelectedMakeModel(String(event.target.value));
            }}
            selectorOptions={makeModelList}
            enableDarkTheme={enableDarkTheme}
          />
        </Box>
        {/* Asset ID */}
        <Box
          sx={{
            paddingRight: '10px',
          }}
        >
          <Typography
            variant="bodyBold"
            display="block"
            mb={'4px'}
            sx={{
              paddingBottom: '20px',
            }}
          >
            {t('asset_id')}
          </Typography>
          <Selector
            minWidth={inputWidth}
            value={selectedAsset?.bumperNumber}
            onChange={(event) => {
              setSelectedAsset(String(event.target.value));
            }}
            selectorOptions={assetList}
            enableDarkTheme={enableDarkTheme}
          />
        </Box>
      </Box>
    </Grid>
  );
};
